import ukFlagImage from "../assets/uk-flag.png";
import srFlagImage from "../assets/sr-flag.png";
import ruFlagImage from "../assets/ru-flag.png";

const languages = [
  {
    name: "English",
    flag: "🇬🇧",
    flagSrc: ukFlagImage,
    code: "en",
  },
  {
    name: "Српски",
    flag: "🇷🇸",
    flagSrc: srFlagImage,
    code: "sr",
  },
  {
    name: "Русский",
    flag: "🇷🇺",
    flagSrc: ruFlagImage,
    code: "ru",
  },
];

export default languages;
